import Link from 'next/link';
import {useMobileOrTablet} from '@helpers/hooks/useWindow';
import {BiChevronRight} from '@assets/react-icons/bi';

export const SingleProductFocusBreadcrumbs = ({
  categoryName,
  categoryLink,
  collectionLink,
  collectionName,
  productName
}) => {
  // console.log({categoryName, categoryLink, collectionLink, collectionName});

  const isMobile = useMobileOrTablet();
  const fontSize = isMobile ? '14px' : '14px';
  categoryLink =
    categoryLink && categoryLink.startsWith('/collections')
      ? categoryLink
      : `/collections/${categoryLink}`;
  categoryLink = categoryLink.replaceAll('//', '/');
  collectionLink = collectionLink && collectionLink.replaceAll('//', '/');

  const showCategory = categoryName && categoryLink && categoryName !== 'Main';

  return (
    <nav className='flex items-center tracking-tight leading-none' aria-label='Breadcrumb'>
      <ol className='inline-flex flex-wrap items-center'>
        <li className=''>
          <Link href='/' className={'hover:underline'}>
            Home
          </Link>
        </li>

        {showCategory && (
          <li className={'flex items-center'}>
            <BreadcrumbsSeparator />
            <Link href={categoryLink} className='whitespace-pre hover:underline'>
              {categoryName}
            </Link>
          </li>
        )}

        {collectionLink && collectionName && (
          <li className={'flex items-center'}>
            <BreadcrumbsSeparator />
            <Link href={collectionLink} className='whitespace-pre hover:underline'>
              {collectionName}
            </Link>
          </li>
        )}

        {productName && (
          <li aria-current='page' className={'flex items-center'}>
            <BreadcrumbsSeparator />
            <span>{productName}</span>
          </li>
        )}
      </ol>
    </nav>
  );
};

const BreadcrumbsSeparator = () => {
  return <BiChevronRight size={16} />;
};
